var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page flex-col"},[_c('div',{staticClass:"group_2 flex-col"},[_c('div',{staticClass:"image-text_1 flex-row justify-between"},[_c('LanhuSideMenu',{attrs:{"contentType":_vm.contentType},on:{"switch":_vm.switchContent}}),_c('LanhuDetailContent',{attrs:{"content":_vm.currentContent,"pdfUrl":_vm.currentPdfUrl}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }